import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import {useStyles} from '@wix/tpa-settings/react'
import {MOBILE_WIDGET_LAYOUT, getEventId} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {Animated} from '../../../../../../../commons/components/animated'
import {isMobile, isSite} from '../../../../../../../commons/selectors/environment'
import stylesParams from '../../../../../stylesParams'
import {useWidgetState} from '../../../../hooks/state-provider'
import {useVisibilityStyles} from '../../../../hooks/use-visibility-styles'
import {getEventBadge, getRibbonData} from '../../../../selectors/events'
import {isItemOpened, shouldShowCountdown} from '../../../../selectors/layout'
import {isMembersVisible} from '../../../../selectors/settings'
import classesV2 from '../../../classes-v2.scss'
import {Countdown} from '../../../countdown'
import {EventBadge} from '../../../event-badge'
import {AdditionalInfoFullDateLocation} from '../../../full-date-location'
import {Ribbon} from '../../../ribbon'
import {RsvpButton} from '../../../rsvp-button'
import {Image} from '../../common/image'
import {AdditionalInfoToggle} from './additional-info-toggle'
import s from './cards-mobile-item.scss'
import {Date} from './date'
import {Description} from './description'
import {Members} from './members'
import {Share} from './share'
import {Title} from './title'

export const CardsMobileItem = ({event, hovered}: {event: ExtendedEvent | Event_V3; hovered: boolean}) => {
  const {
    allBreakpoints: {isListImageEnabled, isListCountdownEnabled, isEventBadgeOnImage, isEventBadgeInEventInfo},
  } = useVisibilityStyles()
  const {get} = useStyles()

  const opened = useWidgetState(state => isItemOpened(state, getEventId(event)))
  const mobile = useWidgetState(isMobile)
  const showMembers = useWidgetState(state => isMembersVisible(state, event))
  const showRibbon = useWidgetState(state => getRibbonData(state, event).visible)
  const animates = useWidgetState(isSite)
  const eventBadge = useWidgetState(state => getEventBadge(state, event))
  const showCountdown = shouldShowCountdown(event)
  const mobileGridLayout = get(stylesParams.mobileWidgetLayoutNew) === MOBILE_WIDGET_LAYOUT.GRID

  return (
    <>
      {isListImageEnabled() && (
        <div className={classNames(s.image, {[s.padding]: !mobileGridLayout})}>
          <Image event={event} />
          {isEventBadgeOnImage(eventBadge?.type) && <EventBadge onImage event={event} />}
        </div>
      )}
      <div className={mobileGridLayout ? s.eventInfoPadding : null}>
        <div className={s.eventInfo}>
          {isEventBadgeInEventInfo(eventBadge?.type) && (
            <EventBadge
              event={event}
              className={classNames(s.eventBadge, {[s.overrideMargin]: showRibbon || showCountdown})}
            />
          )}
          {showRibbon && (
            <Ribbon event={event} className={classNames(s.ribbon, {[s.overrideMargin]: !showCountdown})} />
          )}
          {isListCountdownEnabled() && showCountdown && (
            <div className={s.countdown}>
              <Countdown event={event} />
            </div>
          )}
          <Title event={event} />
          <Date event={event} />
          <AdditionalInfoToggle opened={opened} active={!mobile && (hovered || opened)} />
          <div className={s.additionalInfoContainer}>
            <Animated disabled={!animates} show={opened} height={calculateContentHeight}>
              <div className={s.additionalInfo}>
                <AdditionalInfoFullDateLocation
                  event={event}
                  dateClassName={classesV2.hoverEventDate}
                  locationClassName={classesV2.hoverEventLocation}
                />
                <Description event={event} />
                {showMembers && <Members event={event} />}
                <Share event={event} />
              </div>
            </Animated>
          </div>
          <RsvpButton event={event} fullWidth={mobile} containerClassName={s.buttonContainer} />
        </div>
      </div>
    </>
  )
}

const calculateContentHeight = (element: HTMLElement) => element.offsetHeight + 60
